var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnomaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    viewBox: "0 0 512 512",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m170.666667 0c94.104106 0 170.666666 76.56256 170.666666 170.666667 0 39.373653-13.533866 75.572906-36.018133 104.481706l121.314987 121.3152-30.166614 30.166614-121.3152-121.3152c-28.9088 22.48448-65.108053 36.018346-104.481706 36.018346-94.104107 0-170.666667-76.56256-170.666667-170.666666 0-94.104107 76.56256-170.666667 170.666667-170.666667zm0 148.928-37.258379 91.072-70.2966971.001039c22.8173898 35.275157 62.5043431 58.665628 107.5550761 58.665628s84.737686-23.390471 107.555075-58.665628l-70.296696-.001039zm0-106.2613333c-70.583254 0-128.0000003 57.4167463-128.0000003 128.0000003 0 12.982041 1.9423219 25.518679 5.5516446 37.334593l63.6963557-.00126 58.752-143.5906287 58.730666 143.5906287 63.717689.00126c3.609323-11.815914 5.551645-24.352552 5.551645-37.334593 0-70.583254-57.416747-128.0000003-128-128.0000003z",
    fillRule: "evenodd",
    fill: "#4D6E61",
    transform: "translate(42.666667 42.666667)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnomaly);
export default __webpack_public_path__ + "static/media/anomaly.e63b9303563b41afcf71e7e4baeb893f.svg";
export { ForwardRef as ReactComponent };